import * as R from 'ramda';
import { handleActions } from 'redux-actions';

import * as commonReducers from './common';
import * as actions from '../actions/meeting-notes';

const {
  create,
  update,
  fetch,
  remove,
} = commonReducers.operationTypes;

const createMeetingNoteSuccessReducer = (state, { payload }) => ({
  ...state,
  page: 0,
  [create]: false,
  items: {
    ...state.items,
    [payload._id]: payload,
  },
});

const updateMeetingNoteSuccessReducer = (state, { payload }) => ({
  ...state,
  [update]: false,
  items: {
    ...state.items,
    [payload._id]: {
      ...state.items[payload._id],
      text: payload.text,
      meetingDate: payload.meetingDate,
      meetingTasks: payload.meetingTasks,
      customerTasks: payload.customerTasks,
      meetingInfo: payload.meetingInfo,
    },
  },
});

const deleteMeetingNoteSuccessReducer = (state, { payload }) => ({
  ...state,
  [remove]: false,
  ids: R.without([payload._id], state.ids),
  items: R.dissoc(payload._id, state.items),
});

const fetchMeetingNoteSuccessReducer = (
  state,
  {
    payload: {
      ids,
      meetingNotes = {},
      existsMore,
      notNewPage = false,
      overview = false,
    } = {},
  },
) => {
  const newMeetingNotes = Object.keys(meetingNotes).reduce((acc, key) => {
    let newMeetingNote;

    if (overview) {
      newMeetingNote = {
        ...R.path(['items', key], state),
        ...meetingNotes[key],
      };
    } else {
      const prevData = R.pick(
        ['request', 'requestId', 'feedbackCreators'],
        R.pathOr({}, ['items', key], state),
      );

      newMeetingNote = { ...prevData, ...meetingNotes[key] };
    }

    return R.assoc(key, newMeetingNote, acc);
  }, {});

  return ({
    ...state,
    [fetch]: false,
    page: notNewPage ? state.page : state.page + 1,
    existsMore: R.isNil(existsMore) ? state.existsMore : existsMore,
    ids: R.isNil(ids) ? state.ids : R.union(state.ids, ids),
    items: { ...state.items, ...newMeetingNotes },
    isFetching: false,
  });
};

const resetDataReducer = state => ({
  ...state,
  ids: [],
  page: 0,
  existsMore: false,
  openMonthCard: null,
  openMeetingNote: null,
  ...commonReducers.defaultState,
});

export const meetingNotesReducer = handleActions(
  {
    // create
    [actions.createMeetingNoteRequest]: commonReducers.commonRequestReducer(create),
    [actions.createMeetingNoteFailure]: commonReducers.commonFailureReducer(create),
    [actions.createMeetingNoteSuccess]: createMeetingNoteSuccessReducer,

    // update
    [actions.updateMeetingNoteRequest]: commonReducers.commonRequestReducer(update),
    [actions.updateMeetingNoteFailure]: commonReducers.commonFailureReducer(update),
    [actions.updateMeetingNoteSuccess]: updateMeetingNoteSuccessReducer,

    // delete
    [actions.deleteMeetingNoteRequest]: commonReducers.commonRequestReducer(remove),
    [actions.deleteMeetingNoteFailure]: commonReducers.commonFailureReducer(remove),
    [actions.deleteMeetingNoteSuccess]: deleteMeetingNoteSuccessReducer,

    // fetch
    [actions.fetchMeetingNotesRequest]: commonReducers.commonRequestReducer(fetch),
    [actions.fetchMeetingNotesFailure]: commonReducers.commonFailureReducer(fetch),
    [actions.fetchMeetingNotesSuccess]: fetchMeetingNoteSuccessReducer,

    [actions.setMeetingNoteOpenMonth]: (state, { payload }) =>
      R.assoc('openMonthCard', payload, state),

    [actions.setOpenMeetingNote]: (state, { payload }) =>
      R.assoc('openMeetingNote', payload, state),

    [actions.setPage]: (state, { payload }) =>
      ({ ...state, isFetching: false, page: payload }),

    [actions.resetMeetingNotesData]: resetDataReducer,
  },
  {
    ...commonReducers.defaultState,
    ids: [],
    page: 0,
    existsMore: false,
    openMonthCard: null,
    openMeetingNote: null,
  },
);



// WEBPACK FOOTER //
// ./src/redux/reducers/meeting-notes.js